// ================================================================================
// front-page-scroll.js
// TOP 用のスクリプトファイル
// ================================================================================

// scroll geometry
// --------------------------------------------------------------- //

export default function frontScrollBackground() {

	const frontEntry = document.getElementById('js-front-entry');

	if ( frontEntry ) {

		let height = window.innerHeight;
		let entryPos = document.querySelector('.front-entry-wrapper').getBoundingClientRect().top;
		//let triggerPos = 600;
		let triggerPos = entryPos - height;
		let target = document.getElementById('bg-container-cover');

		window.addEventListener('scroll', function(e) {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			let currentPos = scrollTop;

			if (currentPos > triggerPos) {
				target.classList.add('is-scroll');
			} else {
				target.classList.remove('is-scroll');
			}
		});

	}

}

